import { Component, OnInit } from '@angular/core';
import { referEarnService } from '../../../_services/ReferEarn/referEarn.service';
import { creditHistory } from '../../../_models/Refer&Earn/ReferEarnModel';
@Component({
    selector: 'app-refer-earn',
    templateUrl: './refer-earn.component.html',
    styleUrls: ['./refer-earn.component.scss'],
    providers: [referEarnService]
})
export class ReferEarnComponent implements OnInit {
    creditList: any;
    referralList: any;
    code: string;
    history: creditHistory[] = new Array<creditHistory>();
    public loading = true;

    constructor(private referearnService: referEarnService) { }

    ngOnInit() {
        this.getCreditsList();
        this.getReferralList();
    }
    getCreditsList() {
        this.referearnService.getCredits().subscribe(res => {
            this.creditList = res.json();
            this.history = this.creditList['creditHistory'];
            console.log(this.history[0].id)
        }, error => {

        });
    }
    copyMessage(val: string) {
        const selBox = document.createElement('textarea');
        selBox.style.position = 'fixed';
        selBox.style.left = '0';
        selBox.style.top = '0';
        selBox.style.opacity = '0';
        selBox.value = val;
        document.body.appendChild(selBox);
        selBox.focus();
        selBox.select();
        document.execCommand('copy');
        document.body.removeChild(selBox);
        alert("Referral code has been copied. Share this code to earn rewards. ");

    }
    getReferralList() {
        this.referearnService.getReferral().subscribe(res => {
            this.referralList = res.json();

        })
    }

}



// WEBPACK FOOTER //
// ./src/app/core/pages/refer-earn/refer-earn.component.ts